import React from "react";
import CommonModal from '../../components/common/commonModel';
import AddButtonSection from "../../components/common/AddButtonSection";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../components/common/toast";
import { TOAST_TYPE, FEATURE_MSG } from "../../constants/toast";

export default function DeletePatientVisit({ visible, setVisible, ...props }) {
  const navigate = useNavigate();
  
  const deletePatientVisit = async () => {
    // Mock delete for frontend demonstration
    setTimeout(() => {
      showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.VISIT.DELETED);
      setVisible?.(false, true);
      navigate("/patientVisits");
    }, 1000);
  };

  const submitButtons = [
    {
      type: "primarySuccessButton",
      label: "Yes",
      class: "w-8rem pr-3",
      onClick: () => {
        deletePatientVisit();
      },
    },
    {
      type: "secondaryButton",
      label: "No",
      class: "w-7rem",
      onClick: () => {
        setVisible?.(false);
      },
    },
  ];

  return (
    <div>
      <CommonModal
        visible={visible}
        header="Delete Patient Visit"
        onHide={() => setVisible(false)}
      >
        <div>
          <div className="flex justify-content-center pr-4">
            Would you like to delete this patient visit?
          </div>

          <div className="mt-6 ml-2">
            <AddButtonSection buttons={submitButtons} />
          </div>
        </div>
      </CommonModal>
    </div>
  );
}
